import { Button } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@/common/components';
import { BookingCalendarEventStatus } from '@/common/api/wisoryApiClient';
import { PendingSessionViewModel } from '@/common/utils';
import { trackEvent } from '@/common/services/tracking';
import { CompanyNameWithDescription } from '@/common/components/company-name-with-description';
import styles from './styles.module.scss';

export enum UpcomingSessionStatuses {
  PENDING,
  VERIFIED,
  PERFORMED,
  CANCELLED,
}

type Props = {
  item: PendingSessionViewModel;
  className?: string;
  isAdvisor: boolean;
  status: BookingCalendarEventStatus;
  onSelect?: (session: PendingSessionViewModel) => void;
};

export function PendingSessionItem({ item, status, className = '', isAdvisor, onSelect }: Props) {
  const { t } = useTranslation();
  const bookingId = item.request.bookingId;

  return (
    <div className={classNames(styles.item, className, styles.pending)} data-dd-privacy="mask">
      <div className={styles.statusColumn}>
        <div className={styles.icon}>
          <div className={classNames(styles.iconWrapper, styles.pendingIcon)}>
            <Spinner noAnimation color="pink" />
          </div>
          <span className={styles.pendingText}>{t('home.pending')}</span>
        </div>
      </div>
      <div className={styles.contentColumn}>
        {isAdvisor && (
          <>
            <div className={styles.name}>{item.customerFullName}</div>
            <div className={styles.company}>
              <CompanyNameWithDescription
                companyName={item.customerCompanyName}
                companyId={item.companyId}
              />
            </div>
          </>
        )}

        {!isAdvisor && (
          <>
            <div className={styles.name}>{item.advisorName}</div>
          </>
        )}
      </div>

      <div className={styles.actionColumn}>
        {onSelect && (
          <Button
            onClick={() => {
              trackEvent('User_View_SessionDetails_PendingConfirmation', 'BOOKING DETAIL');
              onSelect?.(item);
            }}
          >
            {t('home.viewDetails')}
          </Button>
        )}
        {bookingId && <div className={styles.bookingIdWrapper}>(ID {bookingId})</div>}
      </div>
    </div>
  );
}
